import { number } from "@recoiljs/refine";
import React from "react";
import { atom, useRecoilState } from "recoil";
import { syncEffect } from "recoil-sync";

export const photoSizeState = atom({
  key: "photoSizeState",
  default: 100,
  effects: [
    syncEffect({
      refine: number(),
    }),
  ],
});

const PhotoSize = () => {
  const [photoSize, setPhotoSize] = useRecoilState(photoSizeState);
  return (
    <input
      defaultValue={photoSize}
      onChange={(e) => setPhotoSize(parseInt(e.target.value))}
      style={{
        position: "absolute",
        bottom: "60px",
        right: "70px",
      }}
      type="range"
      min="10"
      max="5000"
      step="1"
    />
  );
};

export default PhotoSize;
